import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: 'Que comprend exactement mon achat ?',
  a: 'Vous recevez un accès instantané à plus de 100 guides de projets de robots au format PDF, étape par étape, ainsi qu’aux 3 bonus : le Pack Arcade en carton, le guide des loisirs créatifs en 5 minutes et Petits Créateurs : slimes et jeux sensoriels. Tout est livré au format numérique — sans livraison ni attente.',
  tone: 'bg-sky-light'
}, {
  q: 'Quels matériaux dois-je acheter ?',
  a: 'Vous avez déjà presque tout ce dont vous avez besoin à la maison : cartons, bouteilles en plastique, ruban adhésif, élastiques, bouchons, stylos et ciseaux. Chaque projet indique clairement les matériaux nécessaires à l’avance, sans surprise.',
  tone: 'bg-sunshine-light'
}, {
  q: 'À quels âges MakerLab s’adresse-t-il ?',
  a: 'MakerLab est conçu pour les enfants de 4 à 12 ans. Les projets sont organisés par niveau de difficulté : les plus simples sont parfaits pour les plus jeunes avec un peu d’aide parentale, tandis que les projets plus avancés conviennent aux plus grands qui veulent relever un vrai défi d’ingénierie.',
  tone: 'bg-brand-light'
}, {
  q: 'Mon enfant a-t-il besoin d’une expérience préalable ?',
  a: 'Pas du tout. Chaque projet commence de zéro : entièrement illustré, étape par étape, et rédigé dans un langage simple que chaque enfant peut suivre. Aucune connaissance en robotique, programmation ou technique n’est nécessaire. Il suffit de curiosité et de deux mains.',
  tone: 'bg-mint-light'
}, {
  q: 'Comment accéder à mon achat ?',
  a: 'Juste après l’achat, vous recevrez un e-mail avec un lien de téléchargement. Vous pourrez accéder à vos fichiers depuis n’importe quel appareil : téléphone, tablette ou ordinateur. Les PDF peuvent être ouverts, enregistrés et imprimés aussi souvent que vous le souhaitez.',
  tone: 'bg-coral-light'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-41" data-mp="1pojph193l41p">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-42" data-mp="1kqi58czxqyon">
        <SectionHeading eyebrow="Des questions ?" title={<>Questions fréquentes</>} subtitle="Tout ce que vous devez savoir avant de vous lancer." data-id="element-43" data-mp="1koynsj2jmhla" />
        <div className="mt-12 space-y-3" data-id="element-44" data-mp="2dexhwsvlh4wt">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`overflow-hidden rounded-2xl border border-ink/10 ${f.tone}`} data-id="element-45" data-mp="23h99j052fyw6" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-46" data-mp="1zfe8zxuylpjg">
                  <span className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-47" data-mp="2zox8l082gkaq">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-48" data-mp="33pzbps53tghz" />
                </button>
                <AnimatePresence initial={false} data-id="element-49" data-mp="3ievn9z6ddbnc">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-50" data-mp="3ndotd6jbu0dh">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-ink/60" data-id="element-51" data-mp="16s0bcpmq39ry">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}